import { createFileRoute, redirect } from "@tanstack/react-router";

import { sdk } from "@/api/sdk";
import { FinanceOverview } from "@/features/finance/modules/overview/finance-overview";
import { PaymentSetupBanner } from "@/features/finance/modules/payment-setup/payment-setup-banner";
import { hasPermissionInList } from "@/features/navigation/filter-nav-entries";
import { m } from "@/paraglide/messages.js";
import { PermissionAction, PermissionSubject } from "@complete-athlete/enums";

export const Route = createFileRoute("/(private)/finances/")({
  beforeLoad: async () => {
    const { data } = await sdk.users.me.$get.send();
    if (!hasPermissionInList(data?.permissions ?? null, PermissionAction.READ, PermissionSubject.FINANCE)) {
      throw redirect({ to: "/" });
    }
  },
  loader: () => ({ crumb: m.finance_nav_overview() }),
  component: OverviewPage,
});

function OverviewPage() {
  return (
    <div className="grid gap-6">
      <PaymentSetupBanner />
      <FinanceOverview />
    </div>
  );
}
